const cartBn = {
	title: 'আমার বাজারের ব্যাগ',
	clearAll: 'সব সরান',
	itemsInBag: (n) => `${n} টি পণ্য আপনার ব্যাগে রয়েছে`,
	sectionCartItems: 'ব্যাগে রাখা পণ্যসমূহ',
	continueShopping: 'আরো কেনাকাটা করুন',
	orderSummary: 'অর্ডার সারাংশ',
	subtotal: 'সাবটোটাল',
	delivery: 'ডেলিভারি চার্জ',
	free: 'ফ্রি',
	discount: 'ছাড়',
	total: 'মোট',
	couponPlaceholder: 'কুপন কোড লিখুন',
	applyCoupon: 'কুপন প্রয়োগ করুন',
	proceedCheckout: 'চেকআউট করুন',
	trust: {
		securePayment: '১০০% নিরাপদ পেমেন্ট',
		fastDelivery: 'দ্রুত ডেলিভারি',
		cod: 'ক্যাশ অন ডেলিভারি'
	},
	empty: {
		title: 'আপনার কার্ট খালি',
		subtitle: 'মনে হচ্ছে আপনি এখনো কোনো পণ্য কার্টে যোগ করেননি।\nআমাদের সুন্দর পণ্যগুলো দেখুন এবং কেনাকাটা শুরু করুন!',
		cta: 'কেনাকাটা শুরু করুন'
	},
	item: {
		inStock: 'স্টকে আছে',
		removed: 'পণ্যটি কার্ট থেকে সরানো হয়েছে'
	},
	cleared: 'সব পণ্য কার্ট থেকে সরানো হয়েছে'
};

export default cartBn;


